export function isEmpty(data) {
    if (!data) return true;
    if (typeof data === 'string') {
        return data.trim() === '';
    } else if (typeof data === 'object') {
        return Object.keys(data).length === 0;
    } else if (typeof data === 'number') {
        return data == 0;
    }
}